import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient } from '@/apiClient.ts'

type UpdateAttachmentRequest = InferRequestType<
  (typeof apiClient.attachments)[':attachmentId']['$patch']
>['json']
type UpdateAttachmentResponse = InferResponseType<
  (typeof apiClient.attachments)[':attachmentId']['$patch']
>

export type UseUpdateAttachmentArgs = {
  attachmentId: string
} & UpdateAttachmentRequest

export const useUpdateAttachment = (
  options?: UseMutationOptions<
    UpdateAttachmentResponse,
    Error,
    UseUpdateAttachmentArgs
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.attachments[':attachmentId']
        .$patch({
          param: { attachmentId: variables.attachmentId },
          json: {
            name: variables.name,
          },
        })
        .then(async (r) => await r.json())
    },
    mutationKey: ['attachment-update'],
    ...options,
  })
